import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qsv28vpreq: FaireBrandEntity = {
  token: "b_qsv28vpreq",
  type: "brand",
  name: "Zuma Nutrition",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f20e4df7057dca96b4aaffbcde2dd33f99432f10459e3148578ea5e8aee8f3f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/df2a5a9f0f438a8241fb35900867b9564f76e839054a8f12c2e179fbb9271cc4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2f20e4df7057dca96b4aaffbcde2dd33f99432f10459e3148578ea5e8aee8f3f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/df2a5a9f0f438a8241fb35900867b9564f76e839054a8f12c2e179fbb9271cc4.png",
  location: "90505, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Zuma Nutrition: Elevating Wellness with All-Natural, USA-Made Products \n\n \n\nZuma Nutrition is a lifestyle brand crafting premium, all-natural supplements, non-toxic home products, hair care, skin care, kids’ products, and pet products. With over 30 years of holistic wellness research, our organic, sustainably sourced ingredients support gut health and vitality for health-conscious consumers of all ages. Proudly manufactured in the USA and packaged in eco-friendly Miron glass, our therapeutic offerings inspire clean, vibrant living. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:24.463Z",
    importedBy: "entity-db-cli",
  },
};
